import type {
    MembershipIncome,
    MembershipIncomeUpsertDto,
} from '@fruitful/member-profile';

import { requestBuilder } from '../../http/RequestBuilder';

const useUpsertMembershipIncome = requestBuilder.mutation<
    MembershipIncome[],
    MembershipIncomeUpsertDto[]
>({
    endpoint: '/api/membership-income',
    method: 'POST',
});

export default useUpsertMembershipIncome;
